import { Link } from '@tanstack/react-router';
import { Icon } from '../components/Icon.tsx';
import { dv } from '../i18n/dv.ts';

export function NotFound(): JSX.Element {
  return (
    <div className="page">
      <div className="rounded-3xl bg-[hsl(var(--chrome))] p-10 text-center space-y-4">
        <span className="mx-auto grid size-14 place-items-center rounded-full bg-[hsl(var(--secondary-container))] text-[hsl(var(--on-secondary-container))]">
          <Icon name="error" size={28} />
        </span>
        <p className="text-xl text-ink">{dv.notFound.title}</p>
        <Link to="/" className="btn-secondary btn-sm inline-flex">{dv.notFound.home}</Link>
      </div>
    </div>
  );
}
